"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
function createSvgIcon(path, displayName, viewBox) {
    if (viewBox === void 0) { viewBox = '0 0 16 16'; }
    var Component = function (props, ref) { return (react_1.default.createElement(SvgIcon_1.default, __assign({ "data-testid": "".concat(displayName, "Icon"), ref: ref, viewBox: viewBox, overflow: "visible" }, props), path)); };
    if (process.env.NODE_ENV !== 'production') {
        // Need to set `displayName` on the inner component for React.memo.
        // React prior to 16.14 ignores `displayName` on the wrapper.
        Component.displayName = "".concat(displayName, "Icon");
    }
    Component.muiName = SvgIcon_1.default.muiName;
    return react_1.default.memo(react_1.default.forwardRef(Component));
}
exports.default = createSvgIcon;
//# sourceMappingURL=index.js.map